import {
  styled,
  Dialog,
  dialogClasses,
  DialogContent,
  formControlClasses,
  inputBaseClasses,
  inputAdornmentClasses,
  DialogActions,
} from '@mui/material';

export const DialogBillingListBillingFormContainer = styled(Dialog)({
  [`& .${dialogClasses.paper}`]: {
    maxWidth: 700,
    width: '100%',
    minHeight: 600,
  },
});

export const DialogBillingListBillingFormLoadingContainer = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  flex: 1,
});

export const DialogBillingListBillingFormContentContainer = styled(
  DialogContent,
)({
  [`& .${formControlClasses.root} .${inputBaseClasses.root}`]: {
    alignItems: 'flex-end',

    [`& .${inputBaseClasses.input}.${inputBaseClasses.inputAdornedStart}`]: {
      paddingLeft: 0,
    },

    [`& .${inputBaseClasses.input}.${inputBaseClasses.inputAdornedEnd}`]: {
      paddingRight: 0,
    },

    [`& .${inputAdornmentClasses.root}`]: {
      height: 'auto',
      marginBottom: 2,
    },
  },
});

export const DialogBillingListBillingFormActions = styled(DialogActions)({
  justifyContent: 'space-between',
});
